(function () {
    'use strict';

    const module = angular.module('imApp');

    module.component('productEan', {
        templateUrl: 'views/components/views/productEan/productEan.template.html?v=' + module.version,
        controllerAs: 'vm',
        controller: ['$stateParams', '$timeout', '$element', 'utilityService', 'stateService', 'modalService', 'translateService', 'productEanService', function ($stateParams, $timeout, $element, utilityService, stateService, modalService, translateService, productEanService) {

            // #region VARIABLES & DEFINITIONS

            const vm = this;
            let prodId = $stateParams.prod_id;
            let productEanKeyno = $stateParams.productean_keyno;

            let translations = {
                confirm_title: '',
                confirm_message: '',
                confirm_ok_label: '',
                confirm_cancel_label: '',
                error: '',
                ok: ''
            };

            vm.model = {
                mId: 'productEanCtrl',
                productEanKeyno: productEanKeyno,
                eanButtons: [
                    { id: 'erase', icon: 'fa fa-solid fa-eraser', color: 'danger', type: 'danger', onClick: () => vm.model.edit.ean = '' },
                    { id: 'scan', icon: 'fa fa-solid fa-barcode', color: 'primary', type: 'primary', onClick: () => goBarcode() }
                ],
                eanButtons2: [
                    { id: 'new', icon: 'fa fa-solid fa-plus', color: 'primary', type: 'primary', onClick: () => retrieveNextEan() },
                    { id: 'scan', icon: 'fa fa-solid fa-barcode', color: 'primary', type: 'primary', onClick: () => goBarcode() }
                ],
                edit: {},
                lockedPrint: false,
                lockedSave: false,
                lockedDelete: false
            };

		    // #endregion VARIABLES & DEFINITIONS

            // #region TRANSLATION FUNCTION

            async function translate() {
                let data = await translateService.translateBatch(translations);

                Object.keys(translations).forEach((key) => {
                    if (data?.[key]) translations[key] = data[key];
                });
            }

            // #endregion TRANSLATION FUNCTION

            // #region LOAD PROCEDURE FUNCTION CALLS

            async function loadEdit() {
                vm.model.edit = (await productEanService.getProductEan({
                    prod_id: prodId,
                    productean_keyno: productEanKeyno
                }))[0];
            }

            function retrieveNextEan() {
                if (utilityService.validateParmsValue(vm.model.edit.ean, true) !== true) return;

                if (vm.model.edit.ean === '') {
                    productEanService.getNextEan({ prod_keyno: prodId }).then(function (response) {
                        if (response[0].errorcode !== '0') {
                            modalService.show({
                                type: 'warning',
                                title: translations.error,
                                message: response[0].errormessage,
                                buttons: [{
                                    label: translations.ok,
                                    cssClass: 'btn-warning',
                                    action: function (dialogItself) {
                                        dialogItself.close();
                                    }
                                }]
                            });
                        } else {
                            vm.model.edit.ean = response[0].ean;
                        }
                    });
                }
            }

            // #endregion LOAD PROCEDURE FUNCTION CALLS

            // #region SCAN BUTTON FUNCTION

            let goBarcode = function () {
                var wait = function () {
                    var val = $element.find('#' + vm.model.mId)[0].value;

                    if (angular.isString(val) && val !== null && val.length > 0) {
                        vm.model.edit.ean = val;
                        $element.find('#' + vm.model.mId)[0].value = '';
                        return;
                    }

                    $timeout(wait, 250);
                };

                wait();

                window.location = "readbarcode://" + vm.model.mId;
            };

            // #endregion SCAN BUTTON FUNCTION

            // #region MULTI DIRECTION BUTTON FUNCTIONS

            vm.goToFunc = function (state, e) {
                function go(parms) {
                    if (e?.ctrlKey) {
                        stateService.newTab(state, parms);
                    } else {
                        stateService.go(state, parms);
                    }
                }

                switch (state) {
                    case 'selectreport':
                        vm.model.lockedPrint = true;

                        productEanService.saveObj(vm.model.edit).then(function (response) {
                            if (response[0].errorcode !== '0') {
                                modalService.show({
                                    type: 'warning',
                                    title: translations.error,
                                    message: response[0].errormessage,
                                    buttons: [{
                                        label: translations.ok,
                                        cssClass: 'btn-warning',
                                        action: function (dialogItself) {
                                            dialogItself.close();
                                            vm.model.lockedPrint = false;
                                        }
                                    }]
                                });
                            } else {
                                vm.model.lockedPrint = false;
                                state = 'selectreport';

                                go({
                                    webpage_name: stateService.getCurrentName(),
                                    argtype: 'productean_keyno',
                                    argvalue: vm.model.edit.productean_keyno
                                });
                            }
                        });
                        break;
                    default:
                        break;
                }
            };

		    // #endregion MULTI DIRECTION BUTTON FUNCTIONS

            // #region BUTTON SAVE PROCEDURE FUNCTION CALL

            vm.saveChanges = function () {
                vm.model.lockedSave = true;

                productEanService.saveObj(vm.model.edit).then(function (response) {
                    if (response[0].errorcode !== '0') {
                        modalService.show({
                            type: 'warning',
                            title: translations.error,
                            message: response[0].errormessage,
                            buttons: [{
                                label: translations.ok,
                                cssClass: 'btn-warning',
                                action: function (dialogItself) {
                                    dialogItself.close();
                                    vm.model.lockedSave = false;
                                }
                            }]
                        });
                    } else {
                        vm.model.lockedSave = false;
                        stateService.back();
                    }
                });
            }

            // #endregion BUTTON SAVE PROCEDURE FUNCTION CALL

            // #region BUTTON DELETE PROCEDURE FUNCTION CALL

            vm.deleteValues = function () {
                vm.model.lockedDelete = true;

                modalService.confirm({
                    type: 'danger',
                    title: translations.confirm_title,
                    message: translations.confirm_message,
                    okLabel: translations.confirm_ok_label,
                    cancelLabel: translations.confirm_cancel_label
                }).then(() => {
                    productEanService.deleteItem(vm.model.edit).then((response) => {
                        vm.model.lockedDelete = false;
                        stateService.back();
                    }, () => vm.model.lockedDelete = false);
                }, () => vm.model.lockedDelete = false);
            }

            // #endregion BUTTON DELETE PROCEDURE FUNCTION CALL

            // #region FIELD CHANGE MULTI FUNCTIONS

            vm.onChanged = function (value, id) {
                switch (id) {
                    case 'ean':
                        if (utilityService.validateWatchValue(value, vm.model.edit.ean) !== true) return;

                        vm.model.edit.ean = value;

                        if (utilityService.validateParmsValue(vm.model.edit.ean, true) !== true) return;

                        if (vm.model.edit.ean === '') {
                            vm.model.edit.ean = '';
                        }
                        break;
                    default:
                        utilityService.setValueToVariable(value);
                        break;
                }
            };

		    // #endregion FIELD CHANGE MULTI FUNCTIONS

            // #region ON INIT FUNCTION

            vm.$onInit = async function () {
                translate();
                loadEdit();
            }

            // #endregion ON INIT FUNCTION

        }]
    });
})();
